import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from './FormError';
import InputField from './InputField';
import CheckboxField from './CheckboxField';

let DeviceContractSettledForm = ({
  handleSubmit,
  errors,
  successMsg,
  submitting,
}) => {
  return (
    <div className="mar-t">
      <h3>Settle contract</h3>
      <form onSubmit={handleSubmit}>
        <Field component={CheckboxField} name="settled" label="Settled" />
        <Field
          component={InputField}
          name="settled_note"
          label="Settled note"
        />
        {errors && <FormError error={errors} />}
        {successMsg && <p className="text-success">{successMsg}</p>}
        <button className="btn btn-primary" disabled={submitting}>
          Settle contract
        </button>
      </form>
    </div>
  );
};

DeviceContractSettledForm = reduxForm({
  form: 'deviceContractSettleForm',
  enableReinitialize: true,
})(DeviceContractSettledForm);

export default DeviceContractSettledForm;
